const scheduler = {
  methods: {
    getStatus (status) {
      return (this.get_global.defaults.options.scheduler.status && typeof this.get_global.defaults.options.scheduler.status[status] !== 'undefined' ? this.get_global.defaults.options.scheduler.status[status] : {})
    },
    getHistory (type) {
      return (this.get_global.defaults.options.scheduler.history && typeof this.get_global.defaults.options.scheduler.history[type - 1] !== 'undefined' ? this.get_global.defaults.options.scheduler.history[type - 1] : {})
    },
    goTo_ (schedule, action) {
      let routeData = this.$router.resolve({ name: `scheduler:${action}`, params: { id: schedule.id }})
      window.open(routeData.href, '_blank')
    },
    hold_ () {
      //
    },
    cancel_ (schedule) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.scheduler.dialog.cancelConfirm} ${schedule.title}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveAction', { page: 7, type: 2, item: schedule.id })
      })
    },
    status_ () {
      //
    },
    delete_ (schedule) {
      this.$store.dispatch('setOverlay', true)
      this.$root.$dialog.confirm({
        text: `${this.lang.scheduler.dialog.deleteConfirm} ${schedule.title}?`,
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) this.$store.dispatch('saveAction', { page: 7, type: 1, item: schedule.id })
      })
    }
  }
}
export default scheduler
